import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assest/font/common.css';
import '@/assest/font/iconfont.css';
import '@/assest/css/allbtn.css';
import '@/assest/css/common.css';
import '@/assest/css/common.scss';
import App from './App'
import router from './router';
import store from './store'
import axios from '@/assest/axios/axios';
import axios2 from 'axios';
import qs from 'qs';
import { submitMemberChange, startMemberRecovery } from '@/assest/utils/memberRemovalSync';
import ImgPreview from '@/components/ImgPreivewDialog';
import VueCookies from 'vue-cookies'
import VueResumable from 'vue-resumable';
import './directives.js';
import {
  export2Excel
} from '@/assest/utils/util.js';
import echarts_color from '@/assest/utils/echarts_color.js';

Vue.use(store)
Vue.use(router)
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(ImgPreview)
Vue.use(VueResumable)

const host = process.env.NODE_ENV === 'development' ? '/' : '/public'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$memberSyncPost = (url, body, isCurrent = null) => submitMemberChange(axios, url, body, isCurrent)
Vue.prototype.qs = qs;
Vue.prototype.alert = ElementUI.MessageBox.alert;
Vue.prototype.confirm = ElementUI.MessageBox.confirm;
Vue.prototype.prompt = ElementUI.MessageBox.prompt;
Vue.prototype.message = ElementUI.Message;
Vue.prototype.$loading = ElementUI.Loading.service;
Vue.prototype.echarts_color = echarts_color;

var domain = window.location.host,
  port = location.port,
  wurl = window.location.href
if (port != '')
  domain = domain.substr(0, domain.indexOf(':' + port))

Vue.prototype.host = host;
Vue.prototype.vuebaseURL = wurl.substr(0, wurl.indexOf('://')) + '://' + domain;
Vue.prototype.vueuploadURL = wurl.substr(0, wurl.indexOf('://')) + '://' + domain + '/public/upload/';
Vue.prototype.vuestaticURL = wurl.substr(0, wurl.indexOf('://')) + '://' + domain + '/public/static/';
Vue.prototype.axios = axios2;
Vue.prototype.export2Excel = export2Excel;
Vue.prototype.vuestore = store;

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})

startMemberRecovery(axios, ElementUI.Message)

Vue.directive('focus', function (el, binding, vnode) {
  if (binding.value)
    el.querySelector('input').focus()
})

Vue.directive('enterDecimal', {
  inserted: function (el) {
    el.addEventListener("keypress", function (e) {
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if (charcode == 46) {
        if (el.querySelector('input').value.includes('.')) {
          e.preventDefault();
        }
        return;
      } else if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  }
});

Vue.directive('enterInteger', {
  inserted: function (el) {
    el.addEventListener("keypress", function (e) {
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  }
});

var setWechatTitle = function (title, img) {
  if (title === undefined || window.document.title === title) {
    return
  }
  document.title = title
  var mobile = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(mobile)) {
    var iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    // 替换成站标favicon路径或者任意存在的较小的图片即可，支付宝小程序引用默认空白的base64图片会有安全警告
    var _img = /alipay/.test(mobile) ? img : (img ||
      'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
    _img && iframe.setAttribute('src', _img)
    var iframeCallback = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', iframeCallback)
        document.body.removeChild(iframe)
      }, 0)
    }
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
  }
}
Vue.directive('wechat-title', function (el, binding) {
  setWechatTitle(binding.value, el.getAttribute('img-set') || null)
})


// WEBPACK FOOTER //
// ./src/main.js